import { listPhysiciansApi } from "./adminPhysiciansApi";

/** Keys for the admin portal's screen-data cache (see useCachedQuery). */
export const adminQueryKeys = {
  reviewQueue: "admin:review-queue",
  physicians: "admin:physicians",
  /** Prefix — one entry per status filter. */
  invitations: "admin:invitations:",
  patients: "admin:patients:",
  patient: (patientId: string) => `admin:patient:${patientId}`,
  patientPhysician: (patientId: string) => `admin:patient-physician:${patientId}`,
};

/** Physicians list as cached data — shared by the Physicians tab and both assign pickers. */
export const fetchAdminPhysicians = async () => {
  const { data, error } = await listPhysiciansApi();
  return { data: data?.items ?? null, error };
};
